import { IDocumentRequiredRepository } from "domain/contracts/document-required.contracts";
import { DocumentRequired } from "domain/entities/document-required";
import { DocumentRequiredInputFilter } from "domain/models/document-required-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class DocumentRequiredRepository implements IDocumentRequiredRepository {
  async getAll(
    filter: DocumentRequiredInputFilter
  ): Promise<Message<DocumentRequired[]>> {
    const response = await httpClient.get(`/documentRequired`, {
      params: filter,
    });
    return response.data;
  }
}

export default new DocumentRequiredRepository();
